<template>
    <div @click="onClick" :class="[
        buttonClass,
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
    ]">
        <sirit-icon v-if="icon !== undefined && icon !== '' && !loading"
                    :model="icon" :size="size" />
        <sirit-icon v-if="loading" model="refresh-cw" rotate />
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import SiritIcon from '@/components/Commons/SiritIcon.vue'

export default defineComponent({
    name: "Sirit Button Icon",
    components: { SiritIcon },
    props: {
        color: { type: String, required: false, default: 'secondary' },
        icon: { type: String, required: false, default: '' },
        size: { type: String, required: false, default: '20' },
        disabled: { type: Boolean, required: false, default: false },
        loading: { type: Boolean, required: false, default: false }
    },
    emits: ['onClick'],
    setup (props, { emit }) {
        const buttonClass = computed(() => {
            return 'btn-icon-' + props.color
        })
        function onClick() {
            if (!props.disabled) {
                emit('onClick')
            }
        }
        return {
            buttonClass,
            onClick
        }
    }
})
</script>
